// @flow

export const asyncTimeout = (delay: number): Promise<void> => new Promise((resolve) => {
    setTimeout(resolve, delay);
});